import { ActionUpdate, Comment, Task } from '../../interface/task.interface';

import { TaskAssignee } from '../../interface/task_assignee.interface';

export interface TasksState {
    currentOrganizationId: string;
    taskDefinitionId: string;
    selectedTaskId: string;
    selectedTaskType: 'TASK_DEFINITION' | 'TASK_INSTANCE';
    organizationsMap: {
        [organizationId: string]: {
            tasks: Task[];
            taskAssignees: {
                [taskId: string]: TaskAssignee[];
            };
            taskInstances: {
                [taskId: string]: Task[];
            };
            filteredChildTaskInstanceIds: {
                [rootInstanceId: string]: string[];
            };
            comments: {
                [taskId: string]: Comment[];
            };
            actionUpdates: {
                [taskId: string]: ActionUpdate[];
            };
            taskActions: {
                [taskId: string]: {
                    id: string;
                    definition_id: string;
                    action_type: string;
                    description: string;
                    target_params: string;
                    service_user_id: string;
                    is_deleted: string;
                }[];
            };
        };
    };
    futureTaskSchedules: { definition: Task; schedule: string[] }[];
    selectedRootInstanceId: string;
    statusGroups: any[];
}

export const tasksState: TasksState = {
    currentOrganizationId: '',
    taskDefinitionId: '',
    selectedTaskId: '',
    selectedTaskType: undefined,
    organizationsMap: {},
    futureTaskSchedules: [],
    selectedRootInstanceId: '',
    statusGroups: [],
};
